import { render, staticRenderFns } from "./actor-information.vue?vue&type=template&id=2bb059f0&scoped=true&"
import script from "./actor-information.vue?vue&type=script&lang=ts&"
export * from "./actor-information.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb059f0",
  null
  
)

export default component.exports